<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn text v-bind="attrs" v-on="on" class="lang-btn">
        {{ currentLanguage === 'uk' ? 'UA' : currentLanguage.toUpperCase() }}
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(lang, code) in languages"
        :key="code"
        @click="changeLanguage(code)"
      >
        <v-list-item-title>{{ lang }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import '@mdi/font/css/materialdesignicons.css';
import { LOCALE_KEY } from '@/translation';

export default {
  data() {
    return {
      languages: {
        en: 'EN',
        uk: 'UA',
        ru: 'RU',
        ro: 'RO',
      },
    };
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
  },
  methods: {
    changeLanguage(lang) {
      localStorage.setItem(LOCALE_KEY, lang);
      this.$i18n.locale = lang;
    },
  },
};
</script>

<style>
.v-btn {
  text-transform: uppercase;
}
.lang-btn {
  font-size: 18px !important;
  font-weight: normal !important;
}
</style>
